import React from "react";

const StoreRequestsIndex = React.lazy(() => import("./index"));
const EditStoreRequest = React.lazy(() => import("./edit"));

export default [
  { path: "/store/requests/:id/edit", component: EditStoreRequest, name: "Edit Store Request" },
  { path: "/store/requests", component: StoreRequestsIndex, name: "StoreRequests" },
];
